function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("line", {
  x1: 1,
  y1: -1,
  x2: 108.037,
  y2: -1,
  transform: "matrix(-0.456727 0.889607 -0.871852 -0.48977 53.807 0)",
  stroke: "#DA442B",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("line", {
  x1: 1,
  y1: -1,
  x2: 105.308,
  y2: -1,
  transform: "matrix(-0.409219 -0.912436 0.897731 -0.440545 78.9932 97)",
  stroke: "#DA442B",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("line", {
  x1: 82,
  y1: 97.4009,
  x2: 1,
  y2: 97.4009,
  stroke: "#DA442B",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("line", {
  x1: 1,
  y1: -1,
  x2: 67.7153,
  y2: -1,
  transform: "matrix(-0.474822 0.880082 -0.861143 -0.508363 50.9448 36.5244)",
  stroke: "#DA442B",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("line", {
  x1: 1,
  y1: -1,
  x2: 22.1058,
  y2: -1,
  transform: "matrix(-0.421152 -0.90699 0.89153 -0.452962 40.0691 97)",
  stroke: "#DA442B",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("line", {
  x1: 59.1035,
  y1: 56.6846,
  x2: 26.1862,
  y2: 56.6846,
  stroke: "#DA442B",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("line", {
  x1: 56.8137,
  y1: 50.6968,
  x2: 29.0482,
  y2: 50.6968,
  stroke: "#DA442B",
  strokeWidth: 2,
  strokeLinecap: "round"
});

function SvgFooterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 99,
    viewBox: "0 0 83 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterIcon);
export default __webpack_public_path__ + "static/media/footerIcon.fb13005e.svg";
export { ForwardRef as ReactComponent };